import el from '@finn-no/create-element';

export default {
    dependencies: [
        '$element',
        'templateservice',
        'savedsearchesservice',
        'trackingservice',
    ],
    callable(ele, templateservice, savedsearchesservice, trackingService) {
        const savedSearchesToShow = 5;

        update();

        function update() {
            savedsearchesservice
                .getSavedSearchesListForFrontpage()
                .then(getSearchesEle)
                .catch(getErrorEle)
                .then(render);
        }

        function render(searchesEle) {
            clearContents();
            ele.append(searchesEle);
        }

        function clearContents() {
            while (ele.firstChild) {
                ele.firstChild.remove();
            }
        }

        function getSearchesEle(savedSearches) {
            if (savedSearches.length === 0) {
                return el(
                    'p',
                    null,
                    'Hvis du lagrer søk vil de dukke opp her.'
                );
            }

            return el(
                'div',
                null,
                el(
                    'ol',
                    null,
                    savedSearches.slice(0, savedSearchesToShow).map(search =>
                        el(
                            'li',
                            null,
                            el(
                                'a.truncate.blockify.pvs',
                                {
                                    href: search.url,
                                    onclick: handleSavedSearchClick,
                                },
                                search.title
                            )
                        )
                    )
                ),
                el(
                    'p.rightify',
                    null,
                    el(
                        'a',
                        { href: '/user/savedsearches.html' },
                        'Alle lagrede søk'
                    )
                )
            );
        }

        function handleSavedSearchClick() {
            trackingService.trackLaterObj({
                analyticsName: 'search.repeat-saved-search.click',
            });
        }

        function getErrorEle() {
            return el(
                'p',
                null,
                'For øyeblikket klarte vi ikke å hente dine lagrede søk.'
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/savedSearches.js